import {get} from 'lodash'

export const isInSkill = (state, skill) =>
  get(state, `onboarding.skills.${skill.key}.active`, false)
